module.exports = __webpack_public_path__ + "media/assets/kyron_logo-17cdf318dee33f25ff127bd8debddb1c.svg";